module.exports = __webpack_public_path__ + "static/media/share_person5.0a279ba5.png";